<template>
  <div class="space-y-16 max-w-5xl mx-auto">
    <div class="flex -mx-4">
      <div class="w-2/3 px-4">
        <Info v-bind="{ product }" />
      </div>
      <div class="w-1/3 px-4 space-y-4">
        <Brochure v-bind="{ product }" />
        <RouterLink
          class="mx-2 btn btn-brand block text-center"
          :to="{ name: 'admin.products.services.service.requirements' }"
        >
          Requirements
        </RouterLink>
        <PublishUnpublish
          :product-id="serviceId"
          :published="product.publishedAt !== null"
          class="mx-2"
        />
      </div>
    </div>
    <div>
      <RouterLink :to="{ name: 'admin.products.services.service.delete' }" class="btn btn-danger">
        {{ $t('delete') | capitalize }}
      </RouterLink>
    </div>
    <div>
      <RouterView name="modal" />
    </div>
  </div>
</template>

<script>
import { productMethods, productComputed } from '@/store/adminHelper';
import Info from '@/components/Products/Info.vue';
import Brochure from '@/components/Products/Brochure.vue';
import PublishUnpublish from '@/components/Products/PublishUnpublish.vue';

export default {
  name: 'ServiceView',
  components: {
    Info,
    Brochure,
    PublishUnpublish,
  },
  props: {
    serviceId: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...productComputed,
  },
  methods: {
    ...productMethods,
  },
};
</script>
